<template>
  <h5 v-if="isLoading" class="modal-title">
    <i class="fa fa-spinner-third fa-spin" aria-hidden="true"/>
  </h5>
  <div v-else>
    <div class="d-inline-flex gap-8" v-if="changedInvoiceData && changedInvoiceData.changedInvoice">
      <h5 class="modal-title">{{ generatedChangedInfor }}</h5>
      <h5
        class="modal-title"
        style="color: #FF7676; text-decoration: underline; cursor: pointer; width: fit-content"
        @click="() => onClickInvoiceNumber(changedInvoiceData.changedInvoice.id, changedInvoiceData.changedInvoice.ir_invoice_id)"
      >
        {{ changedInvoiceData.changedInvoice.invoice_number }}
      </h5>
    </div>
    <div class="d-inline-flex gap-8" v-else-if="changedInvoiceData && changedInvoiceData.changeInvoices && changedInvoiceData.changeInvoices.length > 0">
      <h5 class="modal-title">{{ generatedChangeInfor }} </h5>
      <h5
        v-for="invoice in changedInvoiceData.changeInvoices"
        class="modal-title"
        style="color: #FF7676; text-decoration: underline; cursor: pointer; width: fit-content"
        @click="() => onClickInvoiceNumber(invoice.id, invoice.ir_invoice_id)"
      >
        {{ invoice.invoice_number }}
      </h5>
    </div>
    <h5 v-else class="modal-title">{{ defaultTitle }}</h5>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from '@/utils/text';

export default {
  name: 'InvoiceViewTitle',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    changedInvoiceData: {
      type: Object,
      default: null,
    },
    defaultTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    generatedChangedInfor() {
      const { status, invoice_number: invoiceNumber } = this.changedInvoiceData.currentInvoice;
      return capitalizeFirstLetter(
        `${this.$t('invoice.invoices')} ${invoiceNumber} ${this.$t(`invoice.invoiceTypes.${status}`)} cho ${this.$t('invoice.invoices')}`,
      );
    },
    generatedChangeInfor() {
      const { status, invoice_number: invoiceNumber } = this.changedInvoiceData.currentInvoice;
      return capitalizeFirstLetter(
        `${this.$t('invoice.invoices')} ${invoiceNumber} ${this.$t(`invoice.invoiceTypes.${status}`)} bởi ${this.$t('invoice.invoices')}`,
      );
    },
  },
  methods: {
    onClickInvoiceNumber(id, irInvoiceId) {
      this.$emit('on-click-invoice-number', {
        pinvoiceId: id,
        pinanceId: irInvoiceId,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-view-title.vue